<template>
    <div class="form-inline">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'FormInline'
};
</script>
